if (typeof BSS_B2B != undefined) {
  if (localStorage.getItem("bogo-customize-isloaded") == "true") {
    $("cart-drawer").addClass("is-visible")
  }

  //fix spam checkout
  setTimeout(() => {
    function handleButtonClick(e) {
      if (BSS_B2B?.cart?.updatedLineItems?.length) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({ "pointer-events": "none", opacity: "0.6" });
        $button.text("Loading ...");
        setTimeout(() => {
          $button.css({ "pointer-events": "unset", opacity: "1" });
          $button.text(oldText);
        }, 2000);
      }
    }

    $(document).on(
      "click dblclick",
      'button[name="checkout"]',
      handleButtonClick
    );
  }, 500);

  BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
    window.location.href = "/checkout";
  };
}
